export const Geolocation = {
  countries: [{ country_id: 1, name: "India" }],
  states: [
    { country_id: 1, state_id: 1, name: "Andaman & Nicobar" },
    { country_id: 1, state_id: 2, name: "Andhra Pradesh" },
    { country_id: 1, state_id: 3, name: "Arunachal Pradesh" },
    { country_id: 1, state_id: 4, name: "Assam" },
    { country_id: 1, state_id: 5, name: "Bihar" },
    { country_id: 1, state_id: 6, name: "Chandigarh" },
    { country_id: 1, state_id: 7, name: "Chhattisgarh" },
    { country_id: 1, state_id: 8, name: "Dadra and Nagar Haveli" },
    { country_id: 1, state_id: 9, name: "Daman & Diu" },
    { country_id: 1, state_id: 10, name: "Delhi" },
    { country_id: 1, state_id: 11, name: "Goa" },
    { country_id: 1, state_id: 12, name: "Gujarat" },
    { country_id: 1, state_id: 13, name: "Haryana" },
    { country_id: 1, state_id: 14, name: "Himachal Pradesh" },
    { country_id: 1, state_id: 15, name: "Jammu & Kashmir" },
    { country_id: 1, state_id: 16, name: "Jharkhand" },
    { country_id: 1, state_id: 17, name: "Karnataka" },
    { country_id: 1, state_id: 18, name: "Kerala" },
    { country_id: 1, state_id: 19, name: "Ladkah" },
    { country_id: 1, state_id: 20, name: "Madhya Pradesh" },
    { country_id: 1, state_id: 21, name: "Maharashtra" },
    { country_id: 1, state_id: 22, name: "Manipur" },
    { country_id: 1, state_id: 23, name: "Meghalaya" },
    { country_id: 1, state_id: 24, name: "Mizoram" },
    { country_id: 1, state_id: 25, name: "Nagaland" },
    { country_id: 1, state_id: 26, name: "Odisha" },
    { country_id: 1, state_id: 27, name: "Puducherry" },
    { country_id: 1, state_id: 28, name: "Punjab" },
    { country_id: 1, state_id: 29, name: "Rajasthan" },
    { country_id: 1, state_id: 30, name: "Sikkim" },
    { country_id: 1, state_id: 31, name: "Tamil Nadu" },
    { country_id: 1, state_id: 32, name: "Telangana" },
    { country_id: 1, state_id: 33, name: "Tripura" },
    { country_id: 1, state_id: 34, name: "Uttar Pradesh" },
    { country_id: 1, state_id: 35, name: "Uttarakhand" },
    { country_id: 1, state_id: 36, name: "West Bengal" },
  ],
  cities: [
    { country_id: 1, state_id: 1, city_id: 1, name: "South Andaman" },
    { country_id: 1, state_id: 2, city_id: 2, name: "Anantapuramu" },
    { country_id: 1, state_id: 2, city_id: 3, name: "Chittoor" },
    { country_id: 1, state_id: 2, city_id: 4, name: "East Godavari" },
    { country_id: 1, state_id: 2, city_id: 5, name: "Gachibowli" },
    { country_id: 1, state_id: 2, city_id: 6, name: "Guntur" },
    { country_id: 1, state_id: 2, city_id: 7, name: "Hyderabad" },
    { country_id: 1, state_id: 2, city_id: 8, name: "Krishna" },
    { country_id: 1, state_id: 2, city_id: 9, name: "Kurnool" },
    { country_id: 1, state_id: 2, city_id: 10, name: "Mahbubnagar" },
    { country_id: 1, state_id: 2, city_id: 11, name: "Medchal–Malkajgiri" },
    { country_id: 1, state_id: 2, city_id: 12, name: "Prakasam" },
    { country_id: 1, state_id: 2, city_id: 13, name: "Ranga Reddy" },
    { country_id: 1, state_id: 2, city_id: 15, name: "Sangareddy" },
    {
      country_id: 1,
      state_id: 2,
      city_id: 16,
      name: "Sri Potti Sriramulu Nellore",
    },
    { country_id: 1, state_id: 2, city_id: 17, name: "Srikakulam" },
    { country_id: 1, state_id: 2, city_id: 18, name: "Tadepalligudem" },
    { country_id: 1, state_id: 2, city_id: 19, name: "Visakhapatnam" },
    { country_id: 1, state_id: 2, city_id: 20, name: "West Godavari" },
    { country_id: 1, state_id: 2, city_id: 21, name: "YSR Kadapa" },
    { country_id: 1, state_id: 3, city_id: 23, name: "Papum pare" },
    { country_id: 1, state_id: 3, city_id: 24, name: "Itanagar" },
    { country_id: 1, state_id: 4, city_id: 25, name: "Cachar" },
    { country_id: 1, state_id: 4, city_id: 26, name: "Dibrugarh" },
    { country_id: 1, state_id: 4, city_id: 27, name: "Jorhat" },
    { country_id: 1, state_id: 4, city_id: 28, name: "Kamrup Metropolitan" },
    { country_id: 1, state_id: 4, city_id: 29, name: "Sonitpur" },
    { country_id: 1, state_id: 5, city_id: 30, name: "Begusarai" },
    { country_id: 1, state_id: 5, city_id: 31, name: "Bhagalpur" },
    { country_id: 1, state_id: 5, city_id: 32, name: "Chandigarh" },
    { country_id: 1, state_id: 5, city_id: 33, name: "East Champaran" },
    { country_id: 1, state_id: 5, city_id: 34, name: "Gaya" },
    { country_id: 1, state_id: 5, city_id: 35, name: "Katihar" },
    { country_id: 1, state_id: 5, city_id: 36, name: "Muzaffarnagar" },
    { country_id: 1, state_id: 5, city_id: 37, name: "Nalanda" },
    { country_id: 1, state_id: 5, city_id: 38, name: "Patna" },
    { country_id: 1, state_id: 5, city_id: 39, name: "Purnea" },
    { country_id: 1, state_id: 5, city_id: 40, name: "Rohtas" },
    { country_id: 1, state_id: 5, city_id: 41, name: "Samastipur" },
    { country_id: 1, state_id: 5, city_id: 42, name: "Vaishali" },
    { country_id: 1, state_id: 6, city_id: 43, name: "Chandigarh" },
    { country_id: 1, state_id: 6, city_id: 44, name: "Mohali" },
    { country_id: 1, state_id: 6, city_id: 45, name: "Panchkula" },
    { country_id: 1, state_id: 6, city_id: 46, name: "Zirakpur" },
    { country_id: 1, state_id: 7, city_id: 47, name: "Bilaspur" },
    { country_id: 1, state_id: 7, city_id: 48, name: "Durg" },
    { country_id: 1, state_id: 7, city_id: 49, name: "Korba" },
    { country_id: 1, state_id: 7, city_id: 50, name: "Raigarh" },
    { country_id: 1, state_id: 7, city_id: 51, name: "Raipur" },
    { country_id: 1, state_id: 7, city_id: 52, name: "Rajnandgaon" },
    { country_id: 1, state_id: 8, city_id: 53, name: "Silvassa" },
    { country_id: 1, state_id: 9, city_id: 54, name: "Diu" },
    { country_id: 1, state_id: 10, city_id: 55, name: "Delhi" },
    { country_id: 1, state_id: 11, city_id: 56, name: "North Goa" },
    { country_id: 1, state_id: 11, city_id: 57, name: "Panaji" },
    { country_id: 1, state_id: 11, city_id: 58, name: "South Goa" },
    { country_id: 1, state_id: 12, city_id: 59, name: "Adalaj" },
    { country_id: 1, state_id: 12, city_id: 60, name: "Ahmedabad" },
    { country_id: 1, state_id: 12, city_id: 61, name: "Ankleshwar" },
    { country_id: 1, state_id: 12, city_id: 62, name: "Anand" },
    { country_id: 1, state_id: 12, city_id: 63, name: "Aravalli" },
    { country_id: 1, state_id: 12, city_id: 64, name: "Banaskantha" },
    { country_id: 1, state_id: 12, city_id: 65, name: "Bharuch" },
    { country_id: 1, state_id: 12, city_id: 66, name: "Bhavnagar" },
    { country_id: 1, state_id: 12, city_id: 67, name: "Bhilad" },
    { country_id: 1, state_id: 12, city_id: 68, name: "Chhatral" },
    { country_id: 1, state_id: 12, city_id: 69, name: "Devbhoomi Dwarka" },
    { country_id: 1, state_id: 12, city_id: 70, name: "Gandhinagar" },
    { country_id: 1, state_id: 12, city_id: 71, name: "Jamnagar" },
    { country_id: 1, state_id: 12, city_id: 72, name: "Junagadh" },
    { country_id: 1, state_id: 12, city_id: 73, name: "Kheda" },
    { country_id: 1, state_id: 12, city_id: 74, name: "Kutch" },
    { country_id: 1, state_id: 12, city_id: 75, name: "Mehsana" },
    { country_id: 1, state_id: 12, city_id: 76, name: "Morbi" },
    { country_id: 1, state_id: 12, city_id: 77, name: "Navsari" },
    { country_id: 1, state_id: 12, city_id: 78, name: "Panchmahal" },
    { country_id: 1, state_id: 12, city_id: 78, name: "Patan" },
    { country_id: 1, state_id: 12, city_id: 78, name: "Porbandar" },
    { country_id: 1, state_id: 12, city_id: 78, name: "Rajkot" },
    { country_id: 1, state_id: 12, city_id: 78, name: "Sabarkantha" },
    { country_id: 1, state_id: 12, city_id: 78, name: "Surat" },
    { country_id: 1, state_id: 12, city_id: 78, name: "Surendranagar" },
    { country_id: 1, state_id: 12, city_id: 78, name: "Vadodara/Baroda" },
    { country_id: 1, state_id: 12, city_id: 78, name: "Valsad" },
    { country_id: 1, state_id: 12, city_id: 78, name: "Vijapur" },
    { country_id: 1, state_id: 12, city_id: 78, name: "Vitthal Udhyognagar" },
    { country_id: 1, state_id: 13, city_id: 79, name: "Ambala" },
    { country_id: 1, state_id: 13, city_id: 80, name: "Bahadurgarh" },
    { country_id: 1, state_id: 13, city_id: 81, name: "Bhiwani" },
    { country_id: 1, state_id: 13, city_id: 82, name: "Chandigarh" },
    { country_id: 1, state_id: 13, city_id: 83, name: "Faridabad" },
    { country_id: 1, state_id: 13, city_id: 84, name: "Gurgaon" },
    { country_id: 1, state_id: 13, city_id: 85, name: "Gurugram" },
    { country_id: 1, state_id: 13, city_id: 86, name: "Hisar" },
    { country_id: 1, state_id: 13, city_id: 87, name: "Jhajjar" },
    { country_id: 1, state_id: 13, city_id: 88, name: "Jind" },
    { country_id: 1, state_id: 13, city_id: 89, name: "Kaithal" },
    { country_id: 1, state_id: 13, city_id: 90, name: "Karnal" },
    { country_id: 1, state_id: 13, city_id: 91, name: "Kurukshetra" },
    { country_id: 1, state_id: 13, city_id: 92, name: "Mahendragarh" },
    { country_id: 1, state_id: 13, city_id: 93, name: "Manesar" },
    { country_id: 1, state_id: 13, city_id: 94, name: "Mewat" },
    { country_id: 1, state_id: 13, city_id: 95, name: "Palwal" },
    { country_id: 1, state_id: 13, city_id: 96, name: "Panchkula" },
    { country_id: 1, state_id: 13, city_id: 97, name: "Panipat" },
    { country_id: 1, state_id: 13, city_id: 98, name: "Rewari" },
    { country_id: 1, state_id: 13, city_id: 99, name: "Rohtak" },
    { country_id: 1, state_id: 13, city_id: 100, name: "Sirsa" },
    { country_id: 1, state_id: 13, city_id: 101, name: "Sonipat" },
    { country_id: 1, state_id: 13, city_id: 102, name: "Yamunanagar" },
    { country_id: 1, state_id: 14, city_id: 103, name: "Hamirpur" },
    { country_id: 1, state_id: 14, city_id: 104, name: "Kangra" },
    { country_id: 1, state_id: 14, city_id: 105, name: "Kullu" },
    { country_id: 1, state_id: 14, city_id: 106, name: "Manali" },
    { country_id: 1, state_id: 14, city_id: 107, name: "Mandi" },
    { country_id: 1, state_id: 14, city_id: 108, name: "Shimla" },
    { country_id: 1, state_id: 14, city_id: 109, name: "Sirmaur" },
    { country_id: 1, state_id: 14, city_id: 110, name: "Solan" },
    { country_id: 1, state_id: 14, city_id: 111, name: "Una" },
    { country_id: 1, state_id: 14, city_id: 112, name: "Lahaul And Spiti" },
    { country_id: 1, state_id: 15, city_id: 113, name: "Jammu" },
    { country_id: 1, state_id: 15, city_id: 114, name: "Srinagar" },
    { country_id: 1, state_id: 16, city_id: 115, name: "Bokaro" },
    { country_id: 1, state_id: 16, city_id: 116, name: "Deoghar" },
    { country_id: 1, state_id: 16, city_id: 117, name: "Dhanbad" },
    { country_id: 1, state_id: 16, city_id: 118, name: "East Singhbhum" },
    { country_id: 1, state_id: 16, city_id: 119, name: "Giridih" },
    { country_id: 1, state_id: 16, city_id: 120, name: "Jamshedpur" },
    { country_id: 1, state_id: 16, city_id: 121, name: "Ranchi" },
    { country_id: 1, state_id: 16, city_id: 122, name: "Seraikela Kharsawan" },
    { country_id: 1, state_id: 16, city_id: 123, name: "Singhbhum" },
    { country_id: 1, state_id: 16, city_id: 124, name: "Palamu" },
    { country_id: 1, state_id: 17, city_id: 125, name: "Bagalkot" },
    { country_id: 1, state_id: 17, city_id: 126, name: "Bengaluru" },
    { country_id: 1, state_id: 17, city_id: 127, name: "Bidar" },
    { country_id: 1, state_id: 17, city_id: 128, name: "Bijapur" },
    { country_id: 1, state_id: 17, city_id: 129, name: "Chikkaballapur" },
    { country_id: 1, state_id: 17, city_id: 130, name: "Chikkamagaluru" },
    { country_id: 1, state_id: 17, city_id: 131, name: "Dakshina Kannada" },
    { country_id: 1, state_id: 17, city_id: 132, name: "Davanagere" },
    { country_id: 1, state_id: 17, city_id: 133, name: "Dharwad" },
    { country_id: 1, state_id: 17, city_id: 134, name: "Hassan" },
    { country_id: 1, state_id: 17, city_id: 135, name: "Kalaburagi" },
    { country_id: 1, state_id: 17, city_id: 136, name: "Kodagu" },
    { country_id: 1, state_id: 17, city_id: 137, name: "Kolar" },
    { country_id: 1, state_id: 17, city_id: 138, name: "Koppala" },
    { country_id: 1, state_id: 17, city_id: 139, name: "Mandya" },
    { country_id: 1, state_id: 17, city_id: 140, name: "Mangalore" },
    { country_id: 1, state_id: 17, city_id: 141, name: "Mysuru" },
    { country_id: 1, state_id: 17, city_id: 142, name: "New Udupi" },
    { country_id: 1, state_id: 17, city_id: 143, name: "Raichur" },
    { country_id: 1, state_id: 17, city_id: 144, name: "Ramanagara" },
    { country_id: 1, state_id: 17, city_id: 145, name: "Shimoga" },
    { country_id: 1, state_id: 17, city_id: 147, name: "Tumkur" },
    { country_id: 1, state_id: 17, city_id: 148, name: "Udupi" },
    { country_id: 1, state_id: 17, city_id: 149, name: "Uttara Kannada" },
    { country_id: 1, state_id: 17, city_id: 150, name: "Vijayanagara" },
    { country_id: 1, state_id: 18, city_id: 151, name: "Alappuzha" },
    { country_id: 1, state_id: 18, city_id: 152, name: "Calicut" },
    { country_id: 1, state_id: 18, city_id: 153, name: "Cochin" },
    { country_id: 1, state_id: 18, city_id: 154, name: "Ernakulam" },
    { country_id: 1, state_id: 18, city_id: 155, name: "Idukki" },
    { country_id: 1, state_id: 18, city_id: 156, name: "JUBAIl" },
    { country_id: 1, state_id: 18, city_id: 157, name: "Kakkanad Kochi" },
    { country_id: 1, state_id: 18, city_id: 158, name: "Kannur" },
    { country_id: 1, state_id: 18, city_id: 159, name: "Kasaragod" },
    { country_id: 1, state_id: 18, city_id: 160, name: "Kochi" },
    { country_id: 1, state_id: 18, city_id: 161, name: "Kollam" },
    { country_id: 1, state_id: 18, city_id: 162, name: "Kottayam" },
    { country_id: 1, state_id: 18, city_id: 163, name: "Kozhikode" },
    { country_id: 1, state_id: 18, city_id: 164, name: "Kuala Lumpur" },
    { country_id: 1, state_id: 18, city_id: 165, name: "Malappuram" },
    { country_id: 1, state_id: 18, city_id: 166, name: "Palakkad" },
    { country_id: 1, state_id: 18, city_id: 167, name: "Palghat" },
    { country_id: 1, state_id: 18, city_id: 168, name: "Pathanamthitta" },
    { country_id: 1, state_id: 18, city_id: 169, name: "Thiruvananthapuram" },
    { country_id: 1, state_id: 18, city_id: 170, name: "Thrissur" },
    { country_id: 1, state_id: 18, city_id: 171, name: "Tiruvalla" },
    { country_id: 1, state_id: 18, city_id: 172, name: "Vadakara" },
    { country_id: 1, state_id: 18, city_id: 173, name: "Wayanad" },
    { country_id: 1, state_id: 19, city_id: 174, name: "Leh" },
    { country_id: 1, state_id: 20, city_id: 175, name: "Balaghat" },
    { country_id: 1, state_id: 20, city_id: 176, name: "Betul" },
    { country_id: 1, state_id: 20, city_id: 177, name: "Bhopal" },
    { country_id: 1, state_id: 20, city_id: 178, name: "Burhanpur" },
    { country_id: 1, state_id: 20, city_id: 179, name: "Chhatarpur" },
    { country_id: 1, state_id: 20, city_id: 180, name: "Chhindwara" },
    { country_id: 1, state_id: 20, city_id: 181, name: "Dewas" },
    { country_id: 1, state_id: 20, city_id: 182, name: "Dhar" },
    { country_id: 1, state_id: 20, city_id: 183, name: "Gwalior" },
    { country_id: 1, state_id: 20, city_id: 184, name: "Hoshangabad" },
    { country_id: 1, state_id: 20, city_id: 185, name: "Indore" },
    { country_id: 1, state_id: 20, city_id: 186, name: "Jabalpur" },
    { country_id: 1, state_id: 20, city_id: 187, name: "Katni" },
    { country_id: 1, state_id: 20, city_id: 188, name: "Khargone" },
    { country_id: 1, state_id: 20, city_id: 189, name: "Mandla" },
    { country_id: 1, state_id: 20, city_id: 190, name: "Mandsaur" },
    { country_id: 1, state_id: 20, city_id: 191, name: "Morena" },
    { country_id: 1, state_id: 20, city_id: 192, name: "Raisen" },
    { country_id: 1, state_id: 20, city_id: 193, name: "Rajgarh" },
    { country_id: 1, state_id: 20, city_id: 194, name: "Ratlam" },
    { country_id: 1, state_id: 20, city_id: 195, name: "Rewa" },
    { country_id: 1, state_id: 20, city_id: 196, name: "Sagar" },
    { country_id: 1, state_id: 20, city_id: 197, name: "Satna" },
    { country_id: 1, state_id: 20, city_id: 198, name: "Tikamgarh" },
    { country_id: 1, state_id: 20, city_id: 199, name: "Ujjain" },
    { country_id: 1, state_id: 21, city_id: 200, name: "Mumbai" },
    { country_id: 1, state_id: 21, city_id: 201, name: "Ahmednagar" },
    { country_id: 1, state_id: 21, city_id: 202, name: "Akola" },
    { country_id: 1, state_id: 21, city_id: 203, name: "Amravati" },
    { country_id: 1, state_id: 21, city_id: 204, name: "Aurangabad" },
    { country_id: 1, state_id: 21, city_id: 205, name: "Buldhana" },
    { country_id: 1, state_id: 21, city_id: 206, name: "Dhule" },
    { country_id: 1, state_id: 21, city_id: 207, name: "Dombivli East" },
    { country_id: 1, state_id: 21, city_id: 208, name: "Jalgaon" },
    { country_id: 1, state_id: 21, city_id: 209, name: "Jalna" },
    { country_id: 1, state_id: 21, city_id: 210, name: "Kolhapur" },
    { country_id: 1, state_id: 21, city_id: 211, name: "Latur" },
    { country_id: 1, state_id: 21, city_id: 212, name: "Lonavala" },
    { country_id: 1, state_id: 21, city_id: 213, name: "Nagaur" },
    { country_id: 1, state_id: 21, city_id: 214, name: "Nanded" },
    { country_id: 1, state_id: 21, city_id: 215, name: "Nasik" },
    { country_id: 1, state_id: 21, city_id: 216, name: "Navi Mumbai" },
    { country_id: 1, state_id: 21, city_id: 217, name: "Osmanabad" },
    { country_id: 1, state_id: 21, city_id: 218, name: "Palghar" },
    { country_id: 1, state_id: 21, city_id: 219, name: "Pune" },
    { country_id: 1, state_id: 21, city_id: 220, name: "Raigad" },
    { country_id: 1, state_id: 21, city_id: 221, name: "Ratnagiri" },
    { country_id: 1, state_id: 21, city_id: 222, name: "Sangli" },
    { country_id: 1, state_id: 21, city_id: 223, name: "Satara" },
    { country_id: 1, state_id: 21, city_id: 224, name: "Shahapur" },
    { country_id: 1, state_id: 21, city_id: 225, name: "Solapur" },
    { country_id: 1, state_id: 21, city_id: 226, name: "Valsad" },
    { country_id: 1, state_id: 22, city_id: 227, name: "Virar" },
    { country_id: 1, state_id: 22, city_id: 228, name: "Imphal West" },
    { country_id: 1, state_id: 22, city_id: 229, name: "Churachandpur" },
    { country_id: 1, state_id: 22, city_id: 230, name: "Ukhrul" },
    { country_id: 1, state_id: 23, city_id: 231, name: "Shillong" },
    { country_id: 1, state_id: 23, city_id: 232, name: "CherraPunji" },
    { country_id: 1, state_id: 24, city_id: 233, name: "Aizwal" },
    { country_id: 1, state_id: 25, city_id: 234, name: "Dimapur" },
    { country_id: 1, state_id: 25, city_id: 235, name: "Kohima" },
    { country_id: 1, state_id: 26, city_id: 236, name: "Baleswar" },
    { country_id: 1, state_id: 26, city_id: 237, name: "Bhubaneshwar" },
    { country_id: 1, state_id: 26, city_id: 238, name: "Rourkela" },
    { country_id: 1, state_id: 26, city_id: 239, name: "Cuttack" },
    { country_id: 1, state_id: 26, city_id: 240, name: "Dhenkanal" },
    { country_id: 1, state_id: 26, city_id: 241, name: "Jagatsinghpur" },
    { country_id: 1, state_id: 26, city_id: 242, name: "Jharsuguda" },
    { country_id: 1, state_id: 26, city_id: 243, name: "Kendujhar" },
    { country_id: 1, state_id: 26, city_id: 244, name: "Khordha" },
    { country_id: 1, state_id: 26, city_id: 245, name: "Koraput" },
    { country_id: 1, state_id: 26, city_id: 246, name: "Puri" },
    { country_id: 1, state_id: 26, city_id: 247, name: "Rayagada" },
    { country_id: 1, state_id: 26, city_id: 248, name: "Sambalpur" },
    { country_id: 1, state_id: 26, city_id: 249, name: "Sundargarh" },
    { country_id: 1, state_id: 27, city_id: 250, name: "Pondicherry" },
    { country_id: 1, state_id: 28, city_id: 251, name: "Amritsar" },
    { country_id: 1, state_id: 28, city_id: 252, name: "Bahawalpur" },
    { country_id: 1, state_id: 28, city_id: 253, name: "Bathinda" },
    { country_id: 1, state_id: 28, city_id: 254, name: "Chandigarh" },
    { country_id: 1, state_id: 28, city_id: 255, name: "Faridkot" },
    { country_id: 1, state_id: 28, city_id: 256, name: "Fatehgarh Sahib" },
    { country_id: 1, state_id: 28, city_id: 257, name: "Gurdaspur" },
    { country_id: 1, state_id: 28, city_id: 258, name: "Hoshiarpur" },
    { country_id: 1, state_id: 28, city_id: 259, name: "Jalandhar" },
    { country_id: 1, state_id: 28, city_id: 260, name: "Kapurthala" },
    { country_id: 1, state_id: 28, city_id: 261, name: "Kasur" },
    { country_id: 1, state_id: 28, city_id: 262, name: "Lahore" },
    { country_id: 1, state_id: 28, city_id: 263, name: "Ludhiana" },
    { country_id: 1, state_id: 28, city_id: 264, name: "Mohali" },
    { country_id: 1, state_id: 28, city_id: 265, name: "Pathankot" },
    { country_id: 1, state_id: 28, city_id: 266, name: "Patiala" },
    { country_id: 1, state_id: 28, city_id: 267, name: "Rupnagar" },
    { country_id: 1, state_id: 28, city_id: 268, name: "Sangrur" },
    { country_id: 1, state_id: 28, city_id: 269, name: "Sri Muktsar Sahib" },
    { country_id: 1, state_id: 29, city_id: 270, name: "Ajmer" },
    { country_id: 1, state_id: 29, city_id: 271, name: "Alwar" },
    { country_id: 1, state_id: 29, city_id: 272, name: "Banswara" },
    { country_id: 1, state_id: 29, city_id: 273, name: "Barmer" },
    { country_id: 1, state_id: 29, city_id: 274, name: "Bharatpur" },
    { country_id: 1, state_id: 29, city_id: 275, name: "Bhilwara" },
    { country_id: 1, state_id: 29, city_id: 276, name: "Bhiwadi" },
    { country_id: 1, state_id: 29, city_id: 277, name: "Bikaner" },
    { country_id: 1, state_id: 29, city_id: 278, name: "Chittorgarh" },
    { country_id: 1, state_id: 29, city_id: 279, name: "Jaipur" },
    { country_id: 1, state_id: 29, city_id: 280, name: "Jaisalmer" },
    { country_id: 1, state_id: 29, city_id: 281, name: "Jhalawar" },
    { country_id: 1, state_id: 29, city_id: 282, name: "Jhunjhunu" },
    { country_id: 1, state_id: 29, city_id: 283, name: "Jodhpur" },
    { country_id: 1, state_id: 29, city_id: 284, name: "Kota" },
    { country_id: 1, state_id: 29, city_id: 285, name: "Nagaur" },
    { country_id: 1, state_id: 29, city_id: 286, name: "Pali" },
    { country_id: 1, state_id: 29, city_id: 287, name: "Rajsamand" },
    { country_id: 1, state_id: 29, city_id: 288, name: "Sawai Madhopur" },
    { country_id: 1, state_id: 29, city_id: 289, name: "Sikar" },
    { country_id: 1, state_id: 29, city_id: 290, name: "Sirohi" },
    { country_id: 1, state_id: 29, city_id: 291, name: "Sri Ganganagar" },
    { country_id: 1, state_id: 29, city_id: 292, name: "Udaipur" },
    { country_id: 1, state_id: 30, city_id: 293, name: "Gangtok" },
    { country_id: 1, state_id: 31, city_id: 294, name: "Ariyalur" },
    { country_id: 1, state_id: 31, city_id: 295, name: "Chattanooga" },
    { country_id: 1, state_id: 31, city_id: 296, name: "Chengalpattu" },
    { country_id: 1, state_id: 31, city_id: 297, name: "Chennai" },
    { country_id: 1, state_id: 31, city_id: 298, name: "Coimbatore" },
    { country_id: 1, state_id: 31, city_id: 299, name: "Cuddalore" },
    { country_id: 1, state_id: 31, city_id: 300, name: "Dindigul" },
    { country_id: 1, state_id: 31, city_id: 301, name: "Erode" },
    { country_id: 1, state_id: 31, city_id: 302, name: "Hosur" },
    { country_id: 1, state_id: 31, city_id: 303, name: "Kanchipuram" },
    { country_id: 1, state_id: 31, city_id: 304, name: "Kanyakumari" },
    { country_id: 1, state_id: 31, city_id: 305, name: "Karur" },
    { country_id: 1, state_id: 31, city_id: 306, name: "Krishnagiri" },
    { country_id: 1, state_id: 31, city_id: 307, name: "Madurai" },
    { country_id: 1, state_id: 31, city_id: 308, name: "Mayiladuthurai" },
    { country_id: 1, state_id: 31, city_id: 309, name: "Nagapattinam" },
    { country_id: 1, state_id: 31, city_id: 310, name: "Namakkal" },
    { country_id: 1, state_id: 31, city_id: 311, name: "Nilgiris" },
    { country_id: 1, state_id: 31, city_id: 312, name: "Pudukkottai" },
    { country_id: 1, state_id: 31, city_id: 313, name: "Ranipet" },
    { country_id: 1, state_id: 31, city_id: 314, name: "Salem" },
    { country_id: 1, state_id: 31, city_id: 315, name: "Thanjavur" },
    { country_id: 1, state_id: 31, city_id: 316, name: "Thiruvallur" },
    { country_id: 1, state_id: 31, city_id: 317, name: "Thoothukudi" },
    { country_id: 1, state_id: 31, city_id: 318, name: "Tiruchirappalli" },
    { country_id: 1, state_id: 31, city_id: 319, name: "Tirunelveli" },
    { country_id: 1, state_id: 31, city_id: 320, name: "Tirupathur" },
    { country_id: 1, state_id: 31, city_id: 321, name: "Tiruppur" },
    { country_id: 1, state_id: 31, city_id: 322, name: "Tiruvallur" },
    { country_id: 1, state_id: 31, city_id: 323, name: "Tiruvannamalai" },
    { country_id: 1, state_id: 31, city_id: 324, name: "Vellore" },
    { country_id: 1, state_id: 31, city_id: 325, name: "Viluppuram" },
    { country_id: 1, state_id: 31, city_id: 326, name: "Virudhunagar" },
    { country_id: 1, state_id: 32, city_id: 327, name: "Adilabad" },
    { country_id: 1, state_id: 32, city_id: 328, name: "Bhadradri Kothagudem" },
    { country_id: 1, state_id: 32, city_id: 329, name: "Hyderabad" },
    { country_id: 1, state_id: 32, city_id: 330, name: "Janjgir–Champa" },
    { country_id: 1, state_id: 32, city_id: 331, name: "Karimnagar" },
    { country_id: 1, state_id: 32, city_id: 332, name: "Khammam" },
    { country_id: 1, state_id: 32, city_id: 333, name: "Medak" },
    { country_id: 1, state_id: 32, city_id: 334, name: "Medchal–Malkajgiri" },
    { country_id: 1, state_id: 32, city_id: 335, name: "Nalgonda" },
    { country_id: 1, state_id: 32, city_id: 336, name: "Nizamabad" },
    { country_id: 1, state_id: 32, city_id: 337, name: "Peddapalli" },
    { country_id: 1, state_id: 32, city_id: 338, name: "Ranga Reddy" },
    { country_id: 1, state_id: 32, city_id: 339, name: "Sangareddy" },
    { country_id: 1, state_id: 32, city_id: 340, name: "Warangal" },
    { country_id: 1, state_id: 33, city_id: 341, name: "Agartala" },
    { country_id: 1, state_id: 34, city_id: 342, name: "Agra" },
    { country_id: 1, state_id: 34, city_id: 343, name: "Aligarh" },
    { country_id: 1, state_id: 34, city_id: 344, name: "Amroha" },
    { country_id: 1, state_id: 34, city_id: 345, name: "Ayodhya" },
    { country_id: 1, state_id: 34, city_id: 346, name: "Azamgarh" },
    { country_id: 1, state_id: 34, city_id: 347, name: "Baghpat" },
    { country_id: 1, state_id: 34, city_id: 348, name: "Barabanki" },
    { country_id: 1, state_id: 34, city_id: 349, name: "Bareilly" },
    { country_id: 1, state_id: 34, city_id: 350, name: "Bhadohi" },
    { country_id: 1, state_id: 34, city_id: 351, name: "Bijnor" },
    { country_id: 1, state_id: 34, city_id: 352, name: "Budaun" },
    { country_id: 1, state_id: 34, city_id: 353, name: "Bulandshahr" },
    { country_id: 1, state_id: 34, city_id: 354, name: "Etah" },
    { country_id: 1, state_id: 34, city_id: 355, name: "Faridabad" },
    { country_id: 1, state_id: 34, city_id: 356, name: "Firozabad" },
    { country_id: 1, state_id: 34, city_id: 357, name: "Gautam Budh Nagar" },
    { country_id: 1, state_id: 34, city_id: 358, name: "Ghaziabad" },
    { country_id: 1, state_id: 34, city_id: 359, name: "Gorakhpur" },
    { country_id: 1, state_id: 34, city_id: 360, name: "Greater Noida" },
    { country_id: 1, state_id: 34, city_id: 361, name: "Hapur" },
    { country_id: 1, state_id: 34, city_id: 362, name: "Jhansi" },
    { country_id: 1, state_id: 34, city_id: 363, name: "Kanpur" },
    { country_id: 1, state_id: 34, city_id: 364, name: "Kanpur Nagar" },
    { country_id: 1, state_id: 34, city_id: 365, name: "Lucknow" },
    { country_id: 1, state_id: 34, city_id: 366, name: "Mathura" },
    { country_id: 1, state_id: 34, city_id: 367, name: "Meerut" },
    { country_id: 1, state_id: 34, city_id: 368, name: "Mirzapur" },
    { country_id: 1, state_id: 34, city_id: 369, name: "Moradabad" },
    { country_id: 1, state_id: 34, city_id: 370, name: "Muzaffarnagar" },
    { country_id: 1, state_id: 34, city_id: 371, name: "Noida" },
    { country_id: 1, state_id: 34, city_id: 372, name: "Pilibhit" },
    { country_id: 1, state_id: 34, city_id: 373, name: "Prayagraj" },
    { country_id: 1, state_id: 34, city_id: 374, name: "Raebareli" },
    { country_id: 1, state_id: 34, city_id: 375, name: "Rampur" },
    { country_id: 1, state_id: 34, city_id: 376, name: "Saharanpur" },
    { country_id: 1, state_id: 34, city_id: 377, name: "Sahibabad" },
    { country_id: 1, state_id: 34, city_id: 378, name: "Shahjahanpur" },
    { country_id: 1, state_id: 34, city_id: 379, name: "Sitapur" },
    { country_id: 1, state_id: 34, city_id: 380, name: "Varanasi" },
    { country_id: 1, state_id: 35, city_id: 381, name: "Almora" },
    { country_id: 1, state_id: 35, city_id: 382, name: "Dehradun" },
    { country_id: 1, state_id: 35, city_id: 383, name: "Haridwar" },
    { country_id: 1, state_id: 35, city_id: 384, name: "Nainital" },
    { country_id: 1, state_id: 35, city_id: 385, name: "Pauri Garhwal" },
    { country_id: 1, state_id: 35, city_id: 386, name: "Rudra Prayag" },
    { country_id: 1, state_id: 35, city_id: 387, name: "Tehri Garhwal" },
    { country_id: 1, state_id: 35, city_id: 388, name: "Mussorie" },
    { country_id: 1, state_id: 35, city_id: 389, name: "Udham Singh Nagar" },
    { country_id: 1, state_id: 36, city_id: 390, name: "Bankura" },
    { country_id: 1, state_id: 36, city_id: 391, name: "Birbhum" },
    { country_id: 1, state_id: 36, city_id: 392, name: "Darjeeling" },
    { country_id: 1, state_id: 36, city_id: 393, name: "Hooghly" },
    { country_id: 1, state_id: 36, city_id: 394, name: "Jalpaiguri" },
    { country_id: 1, state_id: 36, city_id: 395, name: "Kolkata" },
    { country_id: 1, state_id: 36, city_id: 396, name: "Kozhikode" },
    { country_id: 1, state_id: 36, city_id: 397, name: "Nadia" },
    { country_id: 1, state_id: 36, city_id: 398, name: "North 24 Parganas" },
    { country_id: 1, state_id: 36, city_id: 399, name: "Purba Bardhaman" },
    { country_id: 1, state_id: 36, city_id: 400, name: "Purba Medinipur" },
    { country_id: 1, state_id: 36, city_id: 401, name: "Uttar Dinajpur" },
    { country_id: 1, state_id: 36, city_id: 402, name: "West Medinipur" },
  ],
};
